export class WlCloseModal extends Event {
    static type: string = 'wl-close-modal';

    constructor() {
        super(WlCloseModal.type, {bubbles: true, composed: true});
    }
}
